<template>

  <div class="buttons-container">

    <!-- EDIT -->
    <div class="button">
      <v-icon class="mr-1" title="Edit" @click="edit(index)">mdi-pencil</v-icon>
    </div>

    <!-- DELETE -->
    <div class="button">
      <ProxyDeleteButton @click="del(item)"></ProxyDeleteButton>
    </div>

    <!-- MORE OPTIONS -->
    <div class="button">
      <div class="more-options-container" tabindex="-1" @blur="showMoreOptions = false">
        <v-icon @click.stop="showMoreOptions = !showMoreOptions">mdi-dots-horizontal</v-icon>

        <div class="more-options" v-show="showMoreOptions">
          <div>
            <v-card>
              <v-card-text class="pa-0">

                <div v-if="!item.suspended" class="option" @click.stop="suspend(item)">
                  <v-icon class="align-center">mdi-cancel</v-icon>
                  <p class="mb-0 align-center">Suspend</p>
                </div>

                <div v-else class="option" @click.stop="unsuspend(item)">
                  <v-icon class="align-center">mdi-check</v-icon>
                  <p class="mb-0 align-center">Unsuspend</p>
                </div>

              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import ProxyDeleteButton from '../common/ProxyDeleteButton'

export default {
  name: 'TableButtons',
  components: {
    ProxyDeleteButton
  },
  props: ['item', 'index'],
  data () {
    return {
      showMoreOptions: false
    }
  },
  methods: {
    edit (index) {
      this.$emit('edit', index)
    },
    del (item) {
      this.$emit('del', item)
    },
    suspend (item) {
      this.$emit('suspend', item)
    },
    unsuspend (item) {
      this.$emit('unsuspend', item)
    }
  }
}

</script>

<style lang="scss" scoped>

  .buttons-container {
    min-width: 180px;
    height: 48px;
    padding-top: 12px;
  }

  .button {
    width: 30px;
    height: 30px;
    display: inline-block;
  }

  .more-options-container {
    position: relative;
    width: fit-content;
    height: fit-content;
    cursor: pointer;
  }

  .more-options {
    position: absolute;
    width: 300px;
    top: 0;
    right: 30px;
    z-index: 9999;
  }

  .option {
    width: 100%;
    padding: 12px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 6px;
    &:hover {
      background-color: #cccccc;
    }
  }

  .align-center {
    align-self: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/videos/TableButtons.vue